import { useFormState } from 'react-final-form';

import { StaticActions } from '../actions';

/**
 * Получает значение из контекста формы.
 * Если разрешенное значение `undefined`, вместо него возвращается значение `defaultValue`
 * @example
 * let object = { 'a': [{ 'b': { 'c': 3 } }] };
 * useGetValue(object, 'a[0].b.c'); // => 3
 * */
export const useGetValue = () => {
    const { values } = useFormState({ subscription: { values: true } });

    return <T>(
        /** Путь до значения в объекте */
        path?: string,
        /** Значение по умолчанию */
        defaultValue?: T
    ) => StaticActions.getValue<T>(values, path, defaultValue);
};
